import { render, staticRenderFns } from "./editWorkLvScore.vue?vue&type=template&id=de9af2e0&"
import script from "./editWorkLvScore.vue?vue&type=script&lang=js&"
export * from "./editWorkLvScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports